<template>
  <MobileLayerContainer
    :pid="pid"
    :layers="currentLayer"
    :group-name="groupName"
    v-if="mode === 'mobile'"
  />

  <ScreenLayerContainer
    v-else
    :pid="pid"
    :layers="currentLayer"
    :group-name="groupName"
  />
</template>
<script>
import MobileLayerContainer from './mobile/layer-container'
import ScreenLayerContainer from './screen/layer-container'
export default {
  name: 'ICContainer',
  components: {
    MobileLayerContainer,
    ScreenLayerContainer
  },
  inject: ['mode', 'layers'],
  props: {
    pid: {
      type: [Number, String],
      default: () => undefined
    },
    layers: {
      type: Array,
      default: () => []
    },
    groupName: {
      type: String,
      default: () => 'container'
    }
  },
  computed: {
    currentLayer () {
      return this.layers.filter(d => d.pid === this.pid)
    },
  }
}
</script>

<style>
.layer-container {
  width: 100%;
  height: 100%;
  min-height: 120px;
}
.drop-placeholder {
  border: 1px dotted blue;
  box-sizing: border-box;
  background-color: grey;
  opacity: .6;
  border-radius: 2px;
  padding-bottom: 20px;
}
</style>
